import React, { memo } from 'react';
import EmptyScreen from 'components/EmptyScreen';
import { useWeb5Context } from 'lib/Web5Context';
import { emptyGeneralSvg } from 'lib/svgs';

const Empty = memo(() => {
    const { t } = useWeb5Context();

    return (
        <EmptyScreen
            title={t('label_no_filters_selected')}
            illustration={emptyGeneralSvg}
            overrides={{
                root: {
                    style: {
                        marginTop: '0px',
                        backgroundColor: 'initial',
                    },
                },
                emptyView: {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    },
                },
                illustration: {
                    style: {
                        width: '200px',
                        display: 'flex',
                        alignSelf: 'center',
                    },
                },
            }}
        />
    );
});

export default Empty;
